import React from 'react'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import { InvoicesListingProvider } from '../../context/InvoicesListingContext'
import InvoicesPageContent from '../../components/InvoicesPageContent'
import Configuration from '../../Services/Api/Configuration'
import { AuthConsumer } from '../../context/AuthContext'

const Invoices = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Page.invoices.title' })}
           pathname={window.location.origin + NamedRoutes.invoices}
           titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
           description={intl.formatMessage({ id: 'Page.invoices.title' })}
      />

      <AccountLayout permission={Configuration.permissions.invoice.view} content={
        <AuthConsumer>
          {({ taxpayerSubscriptionsData }) => (
            <InvoicesListingProvider hasSubscription={!!taxpayerSubscriptionsData?.hasValidSubscription}>
              <InvoicesPageContent/>
            </InvoicesListingProvider>
          )}
        </AuthConsumer>
      }/>
    </>
  )
}

export default Invoices
